import Box from "@mui/material/Box";

export const Logo = () => {
  return (
    <Box
      component="header"
      sx={{
        left: 0,
        top: 0,
        width: "100%",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          height: 256,
          width: 256,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src="/assets/logo/nero.png"
          alt="Logo"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default Logo;
